import {EntityApiService, ApiClientService} from '@dofleini/security';

class ClientsEstablishmentApiService extends EntityApiService {

    getOneClient = ({clientId}) => ApiClientService.get(this.getPath(`/${clientId}`));

    delete = ({_id}) => ApiClientService.delete(this.getPath(`/${_id}?cascadeDelete=true`));

    setEstablishmentId = (currentId) => {
      localStorage.setItem('establishment-current-id', currentId);
    }

    getEstablishmentId = () => {
      return localStorage.getItem('establishment-current-id');
    }
}

export default new ClientsEstablishmentApiService('/ms-core/api/establishments');
